/**
 * Force Logout Page
 * Emergency page to logout users who can't see the sidebar
 */
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export default function ForceLogout() {
  const { signOut, firebaseUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const performLogout = async () => {
      try {
        // Clear any localStorage data
        localStorage.clear();
        sessionStorage.clear();

        // Sign out from Firebase
        await signOut();

        // Wait a bit to ensure signout completes
        setTimeout(() => {
          navigate('/login');
        }, 500);
      } catch (error) {
        console.error('Error during force logout:', error);
        // Even if there's an error, redirect to login
        setTimeout(() => {
          navigate('/login');
        }, 1000);
      }
    };

    if (firebaseUser) {
      performLogout();
    } else {
      // Already logged out, redirect to login
      navigate('/login');
    }
  }, [firebaseUser, signOut, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center to-black">
      <div className="text-center p-8 bg-surface rounded-xl shadow-2xl max-w-md">
        <div className="mb-6">
          <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-accent/30 mx-auto"></div>
        </div>
        <h1 className="text-2xl font-bold text-ink mb-3">
          Cerrando sesión...
        </h1>
        <p className="text-ink-muted">
          Por favor espera mientras limpiamos tu sesión
        </p>
        <div className="mt-6 text-sm text-ink-subtle">
          <p>🔄 Limpiando datos locales...</p>
          <p>🚪 Cerrando sesión de Firebase...</p>
          <p>↩️ Redirigiendo al login...</p>
        </div>
      </div>
    </div>
  );
}
